import {Types} from "@Common/types";

export const selectWarnings = async (ccEditor:Types.Common.Tools.CcIntegration.Models.CcEditor, warningWasDisplayed) => {

    let sides = ccEditor.surfaces?.map((surface) => surface.name);
    const product = await ccEditor.editor.getProduct();
    const productModel = await product.getProductModel();
    const items = productModel.getAllItems();

    // set the editor function for loading warnings based upon the editor version number - this was changed with version 6
    const spEditorFunction = (ccEditor.ccVersionMajor === 5) ? "_getViolationWarningData" : "getViolationWarningData";

    //violation warnings data contains low DPI and cropped text warnings
    const warnings = await ccEditor.editor.eval(`spEditor.${spEditorFunction}()`);
    warnings.sort(function(first, second){
        //Sort in reverse by the level of error
        return second.qualityViolationState - first.qualityViolationState
    });

    //empty images
    for (let side=0; side < sides.length; side++) {
        for(const key in items) {
            if(items[key].type === "PlaceholderItem"
                && items[key].name !== ""
                && items[key].content === null
                && items[key]?.visible
                && items[key]?.visualizationPermissions?.noPrint === false
                && items[key]?.visualizationPermissions?.noShow === false
                && items[key].parentContainer.parentComponent._name === sides[side]) {
                    ccEditor.changeSide(side, true);
                    ccEditor.editor.selectItems([{'name':items[key].name}]);
                    return;
            }
        }
    }

    //low DPI images
    for (let key in warnings) {
        if(warnings[key].qualityViolationState === 3) {
            let warningItem = items.find(item => { return item?._name == warnings[key]?.name && item?._parentContainer?.parentComponent._name == warnings[key]?.surfaceName });
            if( warningItem?.visible && !warningItem?.visualizationPermissions?.noPrint && !warningItem?.visualizationPermissions?.noShowItem ) {
                ccEditor.changeSide(warnings[key]['surfaceIndex'], true);
                ccEditor.editor.selectItems([{'name':warnings[key].name}]);
                warningWasDisplayed.onChange(true);
                return;
            }
        }
    }

    //empty text
    for(let side=0; side < sides.length; side++) {
        for(const key in items) {
            if( (items[key].type === "BoundedTextItem" || items[key].type === "PathBoundedTextItem")
                && items[key].name !== ""
                && items[key]._locked === false
                && items[key].text === ""
                && items[key].parentContainer.parentComponent._name === sides[side]) {
                    ccEditor.changeSide(side, true);
                    ccEditor.editor.selectItems([{'name':items[key].name}]);
                    return;
            }
        }
    }
    //cropped text
    for(let key in warnings) {
        if(warnings[key].textCropViolationState > 1) {
            let warningItem = items.find(item => { return item?._name == warnings[key]?.name && item?._parentContainer?.parentComponent?._name == warnings[key]?.surfaceName });
            if( warningItem?.visible && !warningItem?.visualizationPermissions?.noPrint && !warningItem?.visualizationPermissions?.noShowItem ) {
                ccEditor.changeSide(warnings[key]['surfaceIndex'], true);
                ccEditor.editor.selectItems([{'name':warnings[key].name}]);
                warningWasDisplayed.onChange(true);
                return;
            }
        }
    }
}
